/* eslint-disable max-len */
import { NoAuthServiceProvider } from '@centecomm/portal-service-react';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import 'react-tooltip/dist/react-tooltip.css';
import setDirectLink from 'utils/setDirectLink';
import FullStoryContext from 'Vendors/FullStory/FullStoryContext';
import useFullStoryInit from 'Vendors/FullStory/Hooks/useInit';
import AuthenticatedRoot from './AuthenticatedRoot';
import ClearLocalStorage from './ClearLocalStorage';
import FriendlyCompany from './FriendlyCompany/FriendlyCompany';
import UserSelect from './UserSelect';

const defaultConfiguration = {
    apiRoot: API_ROOT || '',
    options: {
        headers: {},
    },
};

function ApplicationRoot(): React.ReactElement | null {
    const fullStoryReady = useFullStoryInit();
    const fullStoryContextValue = React.useMemo(() => ({ ready: fullStoryReady }), [fullStoryReady]);

    React.useEffect(() => {
        // Saves pathname to session storage before authentication. This is used for navigating
        // back to link after being authenticated.
        setDirectLink();
    }, []);

    return (
        <>
            <FullStoryContext.Provider value={fullStoryContextValue}>
                <Switch>
                    <Route strict path={`${ROOT}company`}>
                        <NoAuthServiceProvider configuration={defaultConfiguration}>
                            <FriendlyCompany />
                        </NoAuthServiceProvider>
                    </Route>
                    <Route exact path={`${ROOT}clear-local-storage`}>
                        <ClearLocalStorage />
                    </Route>
                    <Route exact path={`${ROOT}login`}>
                        <NoAuthServiceProvider configuration={defaultConfiguration}>
                            <UserSelect />
                        </NoAuthServiceProvider>
                    </Route>
                    <Route strict path={ROOT}>
                        <AuthenticatedRoot />
                    </Route>
                </Switch>
            </FullStoryContext.Provider>
        </>
    );
}

export default ApplicationRoot;
